import React from "react";
import { Image as ImageItem } from "antd";

interface ImageProps {
  src: string;
  width?: string;
  height?: string;
  size?: string;
  alt?: string;
  fit?: "cover" | "contain" | "fill" | "none";
  onClick?: (event: React.MouseEvent<HTMLImageElement>) => void;
  radius?: number | string;
}

const Image = ({
  src,
  width,
  height,
  alt,
  fit = "cover",
  size,
  onClick,
  radius = 0,
}: ImageProps) => {
  return (
    <>
      <ImageItem
        src={src}
        width={size ? size : width ? width : "24px"}
        height={size ? size : height ? height : "24px"}
        alt={alt ? alt : ""}
        preview={false}
        style={{
          objectFit: fit,
          display: "flex",
          verticalAlign: "middle",
          zIndex: 1,
          borderRadius: radius,
        }}
      />
    </>
  );
};

export default Image;
